/**
 * People Constants — Heart of Science v2
 * S10 Wave 1 (People/Researchers CRM)
 */

// Person roles in affiliations
export const PERSON_ROLES = ['researcher', 'founder', 'advisor', 'contact'] as const;
export type PersonRole = typeof PERSON_ROLES[number];

export const PERSON_ROLE_LABELS: Record<PersonRole, string> = {
  researcher: 'Researcher',
  founder: 'Founder',
  advisor: 'Advisor',
  contact: 'Contact',
};

// Project-level person roles (same set as PERSON_ROLES for S10, may diverge later)
export const PROJECT_PERSON_ROLES = ['researcher', 'founder', 'advisor', 'contact'] as const;
export type ProjectPersonRole = typeof PROJECT_PERSON_ROLES[number];

export const PROJECT_PERSON_ROLE_LABELS: Record<ProjectPersonRole, string> = {
  researcher: 'Researcher',
  founder: 'Founder',
  advisor: 'Advisor',
  contact: 'Contact',
};
